import * as React from "react";
import { coordsEqual } from "Types/CartesianSpace";
import { Component } from "react";
import { LinearOrTimeScale } from "Types/D3Extensions";
import ErrorPointForReadingTrend from "./ErrorPointForReadingTrend";
import { DateCoordinateForReadingTrend } from "../../../Types/DateCoordinateForReadingTrend";
import { ScaleLinear } from "d3";

interface ErrorPointsProps {
    errorPoints?: DateCoordinateForReadingTrend[];
    highlightedPoint?: DateCoordinateForReadingTrend | null;
    xScale: LinearOrTimeScale;
    yScale: ScaleLinear<number, number>;
    onHoveredPointChange?(point: DateCoordinateForReadingTrend | null): void;
    onPointDoubleClicked?(point: DateCoordinateForReadingTrend): void;
    onPointRightClicked?(point: DateCoordinateForReadingTrend): void;
    colour: string;
    colourLight: string;
}

export default class ErrorPoints extends Component<ErrorPointsProps> {
    render() {
        const { colourLight } = this.props;

        return (
            <g>
                {this.props.errorPoints?.map((e, index) => this.errorPoint(e, index, colourLight))}

                {this.highlighted()}
            </g>
        );
    }

    private highlighted() {
        const { highlightedPoint, errorPoints, colour } = this.props;

        if (highlightedPoint && errorPoints && errorPoints?.filter(p => coordsEqual(highlightedPoint, p)).length > 0) {
            return this.errorPoint(highlightedPoint, "highlighted", colour);
        } else {
            return null;
        }
    }

    private errorPoint(x: DateCoordinateForReadingTrend, key: string | number, colour: string) {
        return (
            <ErrorPointForReadingTrend
                key={key}
                colour={colour}
                xScale={this.props.xScale}
                yScale={this.props.yScale}
                onPointMouseEnter={() => this.onPointMouseEnter(x)}
                onPointMouseLeave={() => this.onPointMouseLeave()}
                onPointDoubleClicked={this.props.onPointDoubleClicked?.bind(this, x)}
                onPointRightClicked={this.props.onPointRightClicked?.bind(this, x)}
               x={x}
            />
        );
    }

    private onPointMouseEnter(point: DateCoordinateForReadingTrend) {
        const { onHoveredPointChange } = this.props;
        if (onHoveredPointChange) onHoveredPointChange(point);
    }

    private onPointMouseLeave() {
        const { onHoveredPointChange } = this.props;
        if (onHoveredPointChange) onHoveredPointChange(null);
    }
}
